module.exports = __webpack_public_path__ + "static/SeeVita-02-82ebea7fdcf56f4c547eca3550b6a1df.png";